import React, { useState, useCallback } from 'react';
import { FaTelegram, FaDiscord, FaEnvelope, FaComments } from 'react-icons/fa';
import DiscordGuide from '../DiscordGuide/DiscordGuide';
import './CTA.css';

const DISCORD_INVITE = 'https://discord.gg/RstHJvXN4';

const CTA = () => {
  const [emailCopied, setEmailCopied] = useState(false);
  const [discordGuideOpen, setDiscordGuideOpen] = useState(false);

  const openDiscordGuide = (e) => {
    // Ctrl/Cmd/Shift-клик — сразу по ссылке, без инструкции
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    setDiscordGuideOpen(true);
  };

  const closeDiscordGuide = useCallback(() => setDiscordGuideOpen(false), []);

  const openChatwoot = () => {
    if (window.$chatwoot) window.$chatwoot.toggle('open');
  };

  const copyEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText('contact@shadowexam.com');
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-bg-glow cta-bg-glow--l" />
        <div className="cta-bg-glow cta-bg-glow--r" />

        <div className="cta-card">
          <div className="cta-ember" />
          <div className="cta-border" />

          <div className="cta-inner">
            <h2 className="cta-title">Ready for Your Next Challenge?</h2>
            <p className="cta-subtitle">
              Join 1000+ professionals who passed exams and aced interviews. Reach out — we're here 24/7.
            </p>

            <div className="contact-grid">

              <a href="https://t.me/shadowexam_bot" target="_blank" rel="noopener noreferrer" className="cc cc--tg">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaTelegram /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Telegram</span>
                  <span className="cc-badge">Fastest</span>
                </div>
                <span className="cc-desc">Reply in minutes · Available 24/7</span>
                <span className="cc-cta">Open →</span>
              </a>

              <a href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer" className="cc cc--dc" onClick={openDiscordGuide}>
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaDiscord /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Discord</span>
                </div>
                <span className="cc-desc">Message us in 3 clicks · Private thread</span>
                <span className="cc-cta">Open Discord →</span>
              </a>

              <a href="mailto:contact@shadowexam.com" className="cc cc--mail">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaEnvelope /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Email</span>
                </div>
                <span className="cc-desc cc-desc--email" onClick={copyEmail}>
                  {emailCopied ? '✓ Copied!' : 'contact@shadowexam.com'}
                </span>
                <span className="cc-cta">Send Email →</span>
              </a>

              <button onClick={openChatwoot} className="cc cc--chat">
                <div className="cc-icon-wrap">
                  <div className="cc-glow" />
                  <div className="cc-icon"><FaComments /></div>
                </div>
                <div className="cc-meta">
                  <span className="cc-title">Live Chat</span>
                  <span className="cc-badge">Instant</span>
                </div>
                <span className="cc-desc">Chat right now · On this page</span>
                <span className="cc-cta">Start Chat →</span>
              </button>

            </div>
          </div>
        </div>
      </div>

      <DiscordGuide isOpen={discordGuideOpen} onClose={closeDiscordGuide} inviteUrl={DISCORD_INVITE} />
    </section>
  );
};

export default CTA;
